import React, { useEffect, useState } from "react";
import { IUIPropertyDefinitionMap, IWidgetTemplateInstanceProps, IWidgetTemplateProps, registerCardTemplate } from "../../../common/common";
import { WidgetWrapperWithSidebar } from "../../../common/widget-wrappers/WidgetWrapperWithSidebar";
import { ContainerProperty, extractContainerProperties } from "../../../common/ui-props/ContainerProperty";
import { SelectableItem, selectUIProps } from "../../../common/SelectableItem";
import { TextProperty } from "../../../common/ui-props/TextProperty";
import { DataSourceProperty } from "../../../common/ui-props/DataSourceProperty";
import { extractContextData, hasValue, loadInitialData, parseValue } from "../../../../util";
import { EventListProperty, IEventListProps } from "./EventListProperty";
import { format, isValid } from 'date-fns'
import { IAction } from "../../../common/action-editor/ActionEditor";
import classNames from "classnames";
import ActionRenderComponent from "../../../common/components/ActionRenderComponent";
import './EventList.scss';
import { executeAndBind, processInitialSource } from "../../../common/data-source-picker/datasource";



const XPR: React.ForwardRefExoticComponent<React.RefAttributes<IWidgetTemplateInstanceProps> & IWidgetTemplateProps> = React.forwardRef((props, ref) => {

    const { designer } = props;
    let uiProps = props?.uiProps;

    const [loading, setLoading] = useState(false)
    const [contextData, setContextData] = React.useState<any>({})
    const [initialSource, setIntitialSource] = React.useState(props.initialSource);
    const [events, setEvents] = useState<any[]>([])
    const [actionData, setActionData] = React.useState<{ action: IAction, contextData: any }>({ action: null, contextData: {} })


    const defaults: IEventListProps = {
        titleField: 'subject',
        subTitleField: 'description',
        dateField: 'date',
        showTime: false,
        onClickRow: null,
        thumbnailBG: '#2aa3f9',
        thumbnailText: 'white',
        titleColor: '#424242',
        subTitleColor: '#424242',
        seperatorColor: '#ccc',
        titleFontSize: '14',
        subTitleFontSize: '11'
    }

    const XPRProps: IUIPropertyDefinitionMap = {
        "headerContainer": ContainerProperty({
            background: {
                color: "",
                image: {
                    image: "",
                    position: "",
                    size: "",
                },
            }
        }),
        "bodyContainer": ContainerProperty({
            background: {
                color: "",
                image: {
                    image: "",
                    position: "",
                    size: ""
                }
            }
        }),
        'title': TextProperty({ text: '', color: '', size: '' }, 'Title'),
        'source': DataSourceProperty('Source', uiProps.source, uiProps.datasources, props.uxpContext, props.designer, 'dictionary-array'),
        'listProps': EventListProperty('Event List', uiProps.listProps || defaults)
    }

    let { styles: headerStyles } = extractContainerProperties(uiProps.headerContainer)
    let { styles: bodyStyles } = extractContainerProperties(uiProps.bodyContainer)
    let { titleField, subTitleField, dateField, showTime, onClickRow, thumbnailBG, thumbnailText, titleColor, subTitleColor, seperatorColor, titleFontSize, subTitleFontSize } = uiProps?.listProps as IEventListProps || defaults


    React.useImperativeHandle(ref, () => ({
        beforeSave: validateBeforeSave,
        onPreview: validateBeforeSave
    }))

    function validateBeforeSave() {
        // need to implement validations here 
        return true
    }

    React.useEffect(() => {

        processInitialSource(props.designer, props.uxpContext, props.uiProps, initialSource, 'dictionary-array')
            .then(res => {
                if (res) props.designer?.setUIProps(res)
            })
            .catch(e => {
                console.log('exception ', e);

            })

    }, [initialSource]);

    useEffect(() => {
        if (props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')) {

            setEvents([{
                date: '2023-07-16T03:00:00Z',
                subject: 'Team call',
                description: 'team update call'
            }])
        }
        else {

            executeAndBind(props.uxpContext, uiProps.source, uiProps.datasources, {}, contextData)
                .then(res => {
                    setEvents(res)
                })
                .catch(e => {

                })
        }
    }, [props.designer, contextData, uiProps])

    React.useEffect(() => {
        loadInitialDataAndContextData()
    }, [props])

    async function loadInitialDataAndContextData() {
        const { isLoading, initialData } = await loadInitialData(props)
        setLoading(isLoading)

        const _data = await extractContextData(props, initialData, contextData)
        setContextData(_data)
    }

    function getFiledValue(item: any, fieldValuePlaceholder: string, field: string) {
        if (props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')) {
            return item[field] || ''
        }
        if (!hasValue(fieldValuePlaceholder)) return ''
        return '' + parseValue(`{$.${fieldValuePlaceholder.trim()}}`, item) || ''
    }

    function handleRowClick(e: React.MouseEvent, item: any) {
        e.preventDefault()
        if (props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')) {
            return
        }
        setActionData({ action: onClickRow, contextData: { ...contextData, row: item } })
    }

    function renderItem(item: any, key: number) {

        const dtString = getFiledValue(item, dateField, 'date')
        const dt = new Date(dtString)

        const isValidDate = isValid(dt)

        const title = getFiledValue(item, titleField, 'subject')
        const subTitle = getFiledValue(item, subTitleField, 'description')

        return <div className={classNames("event-list-event-item-container", { 'clickable': !!onClickRow && !!onClickRow.type })}
            onClick={e => { handleRowClick(e, item) }}
        >
            <div className="left">
                <div className="day-thumbnail" style={{ backgroundColor: thumbnailBG, color: thumbnailText }} >
                    <div className="month">{isValidDate ? format(dt, 'LLL') : 'invalid datetime'}</div>
                    <div className="date">{isValidDate ? format(dt, 'd') : 'invalid datetime'}</div>
                    {showTime &&
                        <div className="time">{isValidDate ? format(dt, 'hh:MM aa') : 'invalid datetime'}</div>
                    }
                </div>
            </div>
            <div className="right">
                <div className="title" style={{ color: titleColor, fontSize: `${titleFontSize}px` }} >{title}</div>
                {hasValue(subTitleField) &&
                    <div className="sub-title" style={{ color: subTitleColor, fontSize: `${subTitleFontSize}px` }} >{subTitle}</div>
                }
            </div>
        </div>
    }

    function renderEvents() {
        // process and groupd by month and day 
        const _events = [...events]
        _events.sort((a: any, b: any) => (new Date(a[dateField])).getTime() - (new Date(b[dateField])).getTime())

        const grouped: { [date: string]: any[] } = {}

        for (const e of _events) {
            const dt = new Date(e[dateField])
            const dtString = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate()

            if (!grouped[dtString]) grouped[dtString] = []
            grouped[dtString].push(e)
        }

        return <div className="event-list" style={{ '--eventListDaySeperatorColor': seperatorColor, '--eventListDayThumbnailColor': thumbnailBG } as any} >
            {
                Object.keys(grouped).map((date: string, i: number) => {
                    return <div className="event-list-day">
                        {grouped[date].map((event: any, k: number) => renderItem(event, k))}
                    </div>
                })
            }
        </div>
    }

    return <WidgetWrapperWithSidebar
        className="uxp-events-list-card-template-wrapper"
        contextData={contextData}
        uiProps={uiProps}
        propDef={XPRProps}
        designer={designer}
    >
        <div className="list-container" style={bodyStyles}>
            <SelectableItem
                designer={designer}
                props={selectUIProps(uiProps, XPRProps, 'bodyContainer', 'source', 'listProps')}
                contextData={contextData}
                elementId="body-container"
            >
                {renderEvents()}
            </SelectableItem>
        </div>

        <ActionRenderComponent
            designer={props.designer}
            uxpContext={props.uxpContext}
            {...actionData}
            onClose={() => setActionData({ action: null, contextData: {} })}
            onReloadWidget={() => { }}
        />

    </WidgetWrapperWithSidebar>
})


registerCardTemplate({
    id: 'event-list',
    name: 'Event List',
    description: 'A list widget to show upcomming events.',
    template: XPR,
    icon: ['fas', 'clipboard-list-check'],
    complexity: 'medium',
    canDragDropFields: true,
    expectedSchema: 'dictionary-array',
})